import React from 'react';
import { PromoBanner } from '../components/PromoBanner';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WhyCapstone } from '../components/WhyCapstone';
import { ServicesGrid } from '../components/ServicesGrid';
import { PricingTable } from '../components/PricingTable';
import { WaterlessFeature } from '../components/WaterlessFeature';
import { BeforeAfterGallery } from '../components/BeforeAfterGallery';
import { CeramicCoatingSection } from '../components/CeramicCoatingSection';
import { Testimonials } from '../components/Testimonials';
import { ServiceAreas } from '../components/ServiceAreas';
import { QuoteForm } from '../components/QuoteForm';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-[#111111] text-white" data-id="element-293">
      <PromoBanner data-id="element-294" />
      <Navigation data-id="element-295" />

      <main data-id="element-296">
        <HeroSection data-id="element-297" />
        <WhyCapstone data-id="element-298" />
        <ServicesGrid data-id="element-299" />
        <PricingTable data-id="element-300" />
        <WaterlessFeature data-id="element-301" />
        <BeforeAfterGallery data-id="element-302" />
        <CeramicCoatingSection data-id="element-303" />
        <Testimonials data-id="element-304" />
        <ServiceAreas data-id="element-305" />
        <QuoteForm data-id="element-306" />
      </main>

      <Footer data-id="element-307" />
    </div>;
}